const messages = {
  title: 'Ups! Zakaj ste tu?',
  description:
    'Zelo nam je žal zaradi nevšečnosti. Zdi se, da poskušate\n' +
    'dostopiti do strani, ki je bila izbrisana ali nikoli ni obstajala.',
  backHomeButton: 'Nazaj na nadzorno ploščo'
}

export default {
  messages
}
